module.exports = __webpack_public_path__ + "static/media/redalameda.0e14003d.png";


//////////////////
// WEBPACK FOOTER
// ./src/recursos/redalameda.png
// module id = 820
// module chunks = 0